import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import globalVariable from '@/api/global/globalVariable.js' // global Variable 全局变量
import './assets/global.css'
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
//import '@/permission' // permission control
import VueDND from 'awe-dnd'

// 使用moment.js格式化时间
import moment from 'moment'

import common from '@/components/common/Common'

Vue.prototype.common = common;

Vue.prototype.GLOBAL = globalVariable

Vue.use(ElementUI, {
  locale
})
Vue.use(VCharts)
Vue.use(VueDND)
Vue.config.productionTip = false

// 在需要格式化时间的地方使用插值表达式  例：{{ item.date | dateformat('YYYY-MM-DD HH:mm:ss')}}
// 直接在所需要的组件中引入 例：let moment = require("moment"); this.ruleForm.startTime = moment(this.ruleForm.startTime).format('YYYY-MM-DD')
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js